import exportGlobally from "./exportGlobally"
import _ from "lodash"
import { openViaPOST } from "./openViaPOST"
import webviewActions from "./webviewActions"

let __initialized = false

interface AuthInfo {
  participatePath: string
  authenticatedButNotParticipating: boolean
  loginPath: string
  registerPath: string
  logoutPath: string
  isWebview: boolean  
}

export const getAuthEndpoints = () => (window as any).__Neo.authEndpoints as AuthInfo

const initialize = () => {
  if (__initialized) { return }
  __initialized = true
  exportGlobally("auth", authCallbacks)
}

const authCallbacks = {
  login: (redirectAfterLogin?: string) => {
    if (getAuthEndpoints().isWebview) {
      if (getAuthEndpoints().authenticatedButNotParticipating) {
        // already authenticated in webview, just not participating in the Tippspiel
        window.location.href = getAuthEndpoints().participatePath
      } else {
        // After login in App, we must redirect to "/participate"!
        webviewActions.login(getAuthEndpoints().participatePath.replace(/^\//, '') + (redirectAfterLogin ? `?local_redirect_path=${encodeURIComponent(redirectAfterLogin)}` : ''))
      }      
    } else {
      openViaPOST(getAuthEndpoints().loginPath, redirectAfterLogin ? { local_redirect_path: redirectAfterLogin } : undefined)
    }
  },
  register: () => authCallbacks.login(), // openViaPOST(getAuthEndpoints().registerPath),
  logout: () => openViaPOST(getAuthEndpoints().logoutPath),
}

export { initialize, authCallbacks }
